export default __webpack_public_path__ + "static/media/43.9943520e.svg";